// ExhumeAuth lightweight analytics beacon (dev build)
// FLAG(source-map): WEB{s0urc3_m4ps_l34k_th3_s0urc3}
//
// TODO before launch:
//   - the diagnostics log reader (/api/logs?file=/app/logs/app.log) is still wired up
//   - admin diagnostics continue to trust X-Forwarded-For === '10.13.37.42'
//   - STRIP this source map (.map) from the production bundle!
(function () {
  var start = Date.now();
  window.__hav = window.__hav || {};
  window.__hav.t = start;
})();
